let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hZfZJ")).then(() => parcelRequire('5bpoy'));